export interface MenuConfig {
  order: number;
  hidden?: boolean;
}

const menuOrder: Record<string, MenuConfig> = {
  "100": { order: 1 },
  "200": { order: 2 },
  "300": { order: 3 },
  "400": { order: 4 },
  "500": { order: 5 },
  "700": { order: 6 },
  "800": { order: 7 },
  "900": { order: 8 },
  "1000": { order: 9 },
  "600": { order: 10 },
};

export default menuOrder;
